/* Storied Rugs — product gallery + variant picker */
(function(){
  var g = document.querySelector('[data-gallery]');
  if(!g) return;

  var slides = Array.prototype.slice.call(g.querySelectorAll('.pdp-main-img'));
  var strip  = document.getElementById('pdpStrip');
  var thumbs = strip ? Array.prototype.slice.call(strip.querySelectorAll('.pdp-thumb')) : [];
  var count  = document.getElementById('pdpCount');
  var GI = 0, GN = slides.length || 1;

  function show(i){
    if(GN < 1) return;
    if(i < 0) i = GN - 1;
    if(i >= GN) i = 0;
    GI = i;

    slides.forEach(function(s, n){ s.classList.toggle('on', n === i); });
    thumbs.forEach(function(t, n){
      var on = n === i;
      t.classList.toggle('on', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
    if(thumbs[i] && strip){
      // keep the active thumb in view without scrolling the page
      var t = thumbs[i];
      var left = t.offsetLeft - (strip.clientWidth / 2) + (t.offsetWidth / 2);
      strip.scrollTo({ left: left, behavior: 'smooth' });
    }
    if(count) count.textContent = (i + 1);
  }

  window.setMainByIndex = show;
  window.setMain = function(el){ show(parseInt(el.dataset.i, 10) || 0); };
  window.galNav  = function(d){ show(GI + d); };
  window.stripScroll = function(d){ if(strip) strip.scrollBy({ left: d * 270, behavior: 'smooth' }); };

  // keyboard arrows while the gallery has focus
  document.addEventListener('keydown', function(e){
    if(!document.activeElement || !document.activeElement.closest) return;
    if(!document.activeElement.closest('[data-gallery]')) return;
    if(e.key === 'ArrowLeft'){ e.preventDefault(); show(GI - 1); }
    if(e.key === 'ArrowRight'){ e.preventDefault(); show(GI + 1); }
  });

  // swipe on touch devices
  (function(){
    var wrap = g.querySelector('.pdp-main-wrap');
    if(!wrap || GN < 2) return;
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function(e){
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(GI + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  })();
})();

/* ---------- Variant picker ---------- */
(function(){
  var form = document.getElementById('ProductForm');
  if(!form) return;

  var dataEl = form.querySelector('[data-variant-data]');
  var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-option]'));
  if(!dataEl || !selects.length) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); }
  catch(e){ return; }

  var idInput  = form.querySelector('[data-variant-id]');
  var addBtn   = form.querySelector('[data-add-btn]');
  var addLabel = form.querySelector('[data-add-label]');
  var priceEl  = document.querySelector('#pdpPrice [data-price]');
  var compEl   = document.querySelector('#pdpPrice [data-compare]');

  var fmtMoney = window.formatMoney;

  function match(){
    var chosen = selects.map(function(s){ return s.value; });
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var ok = true;
      for(var j = 0; j < chosen.length; j++){
        if(v.options[j] !== chosen[j]){ ok = false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  function update(){
    var v = match();

    if(!v){
      if(addBtn) addBtn.disabled = true;
      if(addLabel) addLabel.textContent = window.productStrings.unavailable;
      return;
    }

    if(idInput) idInput.value = v.id;

    if(addBtn) addBtn.disabled = !v.available;
    if(addLabel) addLabel.textContent = v.available ? window.productStrings.add_to_cart : window.productStrings.sold_out;

    
    if(priceEl) priceEl.textContent = fmtMoney(v.price, {sondakiSifirlar:false});
    if(compEl){
      if(v.compare_at_price && v.compare_at_price > v.price){
        compEl.textContent = fmtMoney(v.compare_at_price, {sondakiSifirlar:false});
        compEl.hidden = false;
      } else {
        compEl.hidden = true;
      }
    }

    // keep the URL shareable and back-button friendly
    if(window.history && window.history.replaceState){
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    // jump the gallery to this variant's image, if it has one
    if(v.featured_media && v.featured_media.position && typeof window.setMainByIndex === 'function'){
      window.setMainByIndex(v.featured_media.position - 1);
    }
  }

  selects.forEach(function(s){ s.addEventListener('change', update); });
})();
